import { Hammer } from '@phosphor-icons/react';
import { Button, EmptyState } from '@reelplicate/ui';
import { Link as RouterLink } from 'react-router';

/** Placeholder for a sidebar destination that isn't built yet. */
export function ComingSoonPage({ title }: { title: string }) {
  return (
    <div className="flex min-h-full items-center justify-center p-8">
      <EmptyState
        icon={Hammer}
        titleAs="h2"
        title={title}
        description="We’re still building this part of Reelplicate."
        actions={
          <Button asChild variant="outline">
            <RouterLink to="/">Back to Home</RouterLink>
          </Button>
        }
      />
    </div>
  );
}
